import { AggregationType, AGG_TYPES } from "~/ui-rtk/constants/charts"
import SegmentedToggle from "../SegmentedToggle/SegmentedToggle"

export type TGranularitySelectorProps = {
  value: AggregationType
  onChange: (granularity: AggregationType) => void
  /** Restrict which options show (defaults to Daily / Weekly / Monthly). */
  options?: AggregationType[]
  className?: string
}

/**
 * Daily / Weekly / Monthly toggle for time-bucketed reports. A thin domain
 * wrapper over {@link SegmentedToggle} (joined variant) so all granularity
 * pickers share one rendering primitive.
 */
export default function GranularitySelector({
  value,
  onChange,
  options,
  className,
}: TGranularitySelectorProps) {
  const items = options
    ? AGG_TYPES.filter(agg => options.includes(agg.type))
    : AGG_TYPES

  return (
    <SegmentedToggle
      variant="joined"
      className={className}
      value={value}
      onChange={v => onChange(v as AggregationType)}
      options={items.map(({ type, long }) => ({
        value: type,
        label: long,
        title: `${long} view`,
      }))}
    />
  )
}
